import { SectionHead, FadeUp } from "./Reveal";
import { openQuote } from "../lib/lenis";

const STEPS = [
  {
    n: "01",
    t: "Tell me the brief",
    d: "Your team, your date, your city, your headcount — through the quote form. Corporate day, conference floor, tour leg or private session.",
  },
  {
    n: "02",
    t: "I design the setup",
    d: "Chairs or tables, room plan, scheduling flow around your agenda — every session planned fascia-first. You provide the space; I handle the rest of the logistics.",
  },
  {
    n: "03",
    t: "Session day",
    d: "I arrive early, set up, deliver, break down. Your people just show up — and leave standing a little taller.",
  },
];

export const Process = () => (
  <section className="relative py-24 lg:py-32" data-testid="process-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead
        eyebrow="How it works"
        title={<>Booking me is <em className="italic text-gold">effortless</em>. That's the point.</>}
      />
      <div className="mt-14 grid md:grid-cols-3 gap-5">
        {STEPS.map((s, i) => (
          <FadeUp key={s.n} delay={i * 0.1} className="h-full">
            <div className="h-full rounded-2xl border border-white/10 bg-ink2 p-8 relative overflow-hidden" data-testid={`process-step-${s.n}`}>
              <span className="absolute -top-3 right-4 font-serif text-[6rem] leading-none text-gold/10 select-none" aria-hidden="true">{s.n}</span>
              <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-gold">Step {s.n}</p>
              <h3 className="mt-4 font-serif text-2xl text-ivory font-light">{s.t}</h3>
              <p className="mt-3 text-sm text-mute leading-relaxed">{s.d}</p>
            </div>
          </FadeUp>
        ))}
      </div>
      <FadeUp delay={0.15} className="mt-12 text-center">
        <button
          data-testid="process-cta"
          onClick={() => openQuote("corporate")}
          className="inline-flex items-center gap-3 rounded-full bg-gold px-9 py-4 font-mono text-[11px] uppercase tracking-[0.18em] font-medium text-ink transition-all duration-300 hover:bg-ivory hover:shadow-[0_0_44px_rgba(212,175,55,0.4)]"
        >
          Start with a quote →
        </button>
      </FadeUp>
    </div>
  </section>
);
